import type {RouteParams} from 'types/routes'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {Index} from 'pages/withAuth/adminPage/alerts/index/index'

export const AlertRoutes: RouteParams[] = [
  {
    key: 'alerts',
    path: WITH_AUTH_ADMIN_PATHS.ALERTS.INDEX,
    component: Index,
    exact: true,
    whiteList: ['full_admin', 'office_admin', 'limited_admin'],
  },
]
